import { render } from "./HistoryComponent.vue?vue&type=template&id=2146e41d&ts=true"
import script from "./HistoryComponent.vue?vue&type=script&lang=ts"
export * from "./HistoryComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__